var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 0V1.5H0V0H1.5ZM1.5 3V4.5H0V3H1.5ZM1.5 6V7.5H0V6H1.5ZM1.5 9V10.5H0V9H1.5ZM1.5 12V13.5H0V12H1.5ZM1.5 15V16.5H0V15H1.5ZM1.5 18V19.5H0V18H1.5ZM0 21H1.5V22.5H0V21ZM1.5 24V22.5H3V24H1.5ZM4.5 0V1.5H3V0H4.5ZM4.5 24V22.5H6V24H4.5ZM7.5 24V22.5H9V24H7.5ZM7.5 0V1.5H6V0H7.5ZM10.5 0V1.5H9V0H10.5ZM13.5 0V1.5H12V0H13.5ZM16.5 0V1.5H15V0H16.5ZM18 3H16.5V1.5H18V3ZM18 4.5V6H16.5V4.5H18ZM16.5 9V7.5H18V9H16.5ZM16.5 12V10.5H18V12H16.5ZM13.5 15V13.5H19.5V15H13.5ZM12 22.5H22.5V24H10.5V12H12V22.5ZM13.5 16.5H18V18H13.5V16.5ZM13.5 21V19.5H21V21H13.5Z",
    fill: "#87909B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.d621a49cfcfe5a35180f1d17970a6cf1.svg";
export { ForwardRef as ReactComponent };